<template>
  <div
    class="container"
    oncopy="return false"
    oncut="return false"
    onpaste="return false"
  >
    <div v-if="loading" class="row">
      <div class="col-lg-12 col-xs-12 videoPainel bg-white p-3 shadow_bar">
        <sweetalert-icon icon="loading" />
      </div>
    </div>
    <div v-else class="row">
      <div class="col-lg-12 col-xs-12 videoPainel bg-white p-3 shadow_bar mb-5">
        <div v-if="show_evaluation_start" class="row">
          <div class="col-lg-12 col-xs-12">
            <h3 class="center" style="color: #000">
              {{ evaluations[setup_index].evaluation.name }}
            </h3>
          </div>
          <div
            v-if="evaluations[setup_index].evaluation.description"
            class="col-lg-12 col-xs-12 ml-5 mr-5"
            style="max-width: fit-content; word-wrap: break-word"
          >
            <span
              style="color: #000"
              v-html="evaluations[setup_index].evaluation.description"
            />
          </div>
        </div>

        <div
          v-if="
            evaluations[setup_index].evaluation.customs_checkbox &&
            show_evaluation_start
          "
          class="col-12"
        >
          <div
            v-for="(checkbox, checkbox_index) in evaluations[setup_index]
              .evaluation.customs_checkbox"
            :key="`checkbox-${checkbox_index}`"
          >
            <label>
              <input
                v-model="selectedCheckboxes"
                :value="checkbox"
                class="mt-2"
                type="checkbox"
              />
              <span v-html="checkbox" />
            </label>
          </div>
        </div>

        <div v-if="show_evaluation_start" class="row">
          <div class="col-lg-4 col-xs-12 mt-3" />
          <div class="col-lg-4 col-xs-12 mt-3">
            <button
              :disabled="
                evaluations[setup_index].evaluation.customs_checkbox &&
                evaluations[setup_index].evaluation.customs_checkbox.length >
                  0 &&
                selectedCheckboxes.length === 0
              "
              class="btn btn-primary full"
              @click="showEvaluationStart(false)"
            >
              Iniciar
            </button>
          </div>
          <div class="col-lg-4 col-xs-12 mt-3" />
        </div>
        <!--        @click="startCountdown(), showEvaluationStart(false)"-->

        <div v-if="!show_evaluation_start">
          <div class="row">
            <div class="col-lg-12 col-xs-12">
              <h3 class="center" style="color: #000">Responda as perguntas:</h3>
            </div>
          </div>
          <div v-if="total_steps > 1" class="row">
            <div class="col-12 pl-3 pr-3">
              <transition apper mode="out-in" name="fade">
                <StepIndicator
                  :current="setup_index"
                  :currentColor="'#00a0d6'"
                  :total="total_steps"
                  class="mt-3"
                  defaultColor="#53358b"
                ></StepIndicator>
              </transition>
            </div>
          </div>
          <div class="row">
            <div class="col-12 pl-3 pr-3">
              <div class="tab">
                <div class="row mt-3">
                  <div class="col-12">
                    <div
                      class="f18"
                      style="color: #000 !important"
                      v-html="mountTitle"
                    ></div>
                  </div>
                </div>
                <hr />
                <div
                  v-if="
                    evaluations[setup_index].questions[question_index]
                      .response_type == text_type
                  "
                  class="row mb-3"
                >
                  <div class="col-lg-12 col-12">
                    <TextType
                      :currentTime="currentTime"
                      :index="question_index"
                      :is_evaluation="true"
                      :question="
                        evaluations[setup_index].questions[question_index]
                      "
                      @nextQuestion="nextQuestion"
                    />
                  </div>
                </div>
                <div
                  v-if="
                    evaluations[setup_index].questions[question_index]
                      .response_type == video_type
                  "
                  class="row mb-3"
                >
                  <div class="col-lg-3 col-12" />
                  <div class="col-lg-6 col-12">
                    <VideoJSRecord
                      :currentTime="currentTime"
                      :index="question_index"
                      :is_evaluation="true"
                      :question="
                        evaluations[setup_index].questions[question_index]
                      "
                      @nextQuestion="nextQuestion"
                    />
                  </div>
                  <div class="col-lg-3 col-12" />
                </div>
                <div
                  v-if="
                    evaluations[setup_index].questions[question_index]
                      .response_type == multiple_choices_type
                  "
                  class="row mb-3"
                >
                  <div class="col-lg-12 col-12">
                    <MultipleChoices
                      :currentTime="currentTime"
                      :index="question_index"
                      :is_evaluation="true"
                      :question="
                        evaluations[setup_index].questions[question_index]
                      "
                      @nextQuestion="nextQuestion"
                    />
                  </div>
                </div>
                <div
                  v-if="
                    evaluations[setup_index].questions[question_index]
                      .response_type == yer_or_no_type
                  "
                  class="row mb-3"
                >
                  <div class="col-lg-12 col-12">
                    <YesOrNo
                      :currentTime="currentTime"
                      :index="question_index"
                      :is_evaluation="true"
                      :question="
                        evaluations[setup_index].questions[question_index]
                      "
                      @saveAnswers="nextQuestion"
                    />
                  </div>
                </div>
                <div
                  v-if="
                    evaluations[setup_index].questions[question_index]
                      .response_type == monetary_type
                  "
                  class="row mb-3"
                >
                  <div class="col-lg-12 col-12">
                    <MonetaryType
                      :currentTime="currentTime"
                      :index="question_index"
                      :is_evaluation="true"
                      :question="
                        evaluations[setup_index].questions[question_index]
                      "
                      @saveAnswers="nextQuestion"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div style="text-align: center; margin-top: 40px">
              <span>
                Questão {{ question_index + 1 }} de
                {{ evaluations[setup_index].questions.length }}
              </span>
            </div>
          </div>
        </div>
        <div
          v-if="
            has_timer &&
            is_timer_counting &&
            !this.evaluations[this.setup_index].evaluation.time_per_question
          "
          class="row"
        >
          <div class="col">
            <p style="font-size: 16px; color: black">
              <b
                >Tempo de prova: {{ timer_minute }}:{{
                  timer_second <= 9 ? "0" + timer_second : timer_second
                }}</b
              >
            </p>
          </div>
        </div>
        <div
          v-if="
            has_timer &&
            is_timer_counting &&
            this.evaluations[this.setup_index].evaluation.time_per_question
          "
          class="row"
        >
          <div class="col">
            <p style="font-size: 16px; color: black">
              <b
                >Tempo: {{ question_minutes }}:{{
                  question_seconds <= 9
                    ? "0" + question_seconds
                    : question_seconds
                }}</b
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepIndicator from "vue-step-indicator";
import VideoJSRecord from "components/VideoJSRecord.vue";
import VideoJSRecordMobile from "components/VideoJSRecordMobile.vue";
import MultipleChoices from "pages/Jobs/MultipleChoices.vue";
import TextType from "pages/Jobs/TextType.vue";
import YesOrNo from "pages/Jobs/YesOrNo.vue";
import MonetaryType from "pages/Jobs/MonetaryType.vue";

import {
  isChrome,
  isMobile,
  isSafari,
  mobileModel,
  mobileVendor,
  osName,
} from "mobile-device-detect";

export default {
  props: ["evaluations", "candidate", "job"],

  components: {
    StepIndicator,
    VideoJSRecord,
    VideoJSRecordMobile,
    MultipleChoices,
    TextType,
    YesOrNo,
    MonetaryType,
  },

  data() {
    return {
      timer_second: 0,
      timer_minute: 0,
      question_minutes: 0,
      question_seconds: 0,
      countdown: null,
      general_timer_interval: null,
      question_index: 0,
      setup_index: 0,
      total_steps: 0,
      video_type: 0,
      text_type: 1,
      multiple_choices_type: 2,
      yer_or_no_type: 3,
      monetary_type: 4,
      evaluation_answer: {},
      ios: false,
      timer: 0,
      currentTime: 0,
      show_evaluation_start: true,
      loading: true,
      is_timer_counting: false,
      has_timer: false,
      selectedCheckboxes: [],
    };
  },
  mounted() {
    console.log(this.job);
    if (
      localStorage.getItem("timer_second") &&
      localStorage.getItem("timer_second") !== "end"
    ) {
      this.timer_second = localStorage.getItem("timer_second");
    }
    if (
      localStorage.getItem("timer_minute") &&
      localStorage.getItem("timer_minute") !== "end"
    ) {
      this.timer_minute = localStorage.getItem("timer_minute");
    }
    if (
      localStorage.getItem("timer_second") &&
      localStorage.getItem("timer_second") == "end"
    ) {
      localStorage.setItem("timer_second", this.timer_second);
      localStorage.setItem("timer_minute", this.timer_minute);
    }
    this.total_steps = this.evaluations.length;

    if (this.evaluations[this.setup_index].questions.length == 0) {
      this.nextEvaluation();
    } else {
      this.evaluation_answer = {
        question_id:
          this.evaluations[this.setup_index].questions[this.question_index].id,
      };
    }

    if (mobileModel == "iPhone") {
      this.ios = true;
    }

    if (
      (isMobile || mobileVendor == "Apple" || mobileVendor == "none") &&
      isSafari
    ) {
      this.ios = true;
    }

    if (isMobile && osName == "Android" && !isChrome) {
      this.ios = true;
    }
    this.startTimer();
    this.countFocusPage();
    document.addEventListener("contextmenu", (event) => event.preventDefault());
    document.addEventListener("keyup", (e) => {
      if (e.key == "PrintScreen") {
        navigator.clipboard.writeText("");
      }
    });

    document.addEventListener("keydown", (e) => {
      if (
        e.ctrlKey &&
        (e.code == "KeyP" || e.code == "KeyS" || e.code == "KeyU")
      ) {
        e.cancelBubble = true;
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.ctrlKey && e.shiftKey && (e.code == "KeyC" || e.code == "KeyI")) {
        e.cancelBubble = true;
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
    document.addEventListener("keydown", (e) => {
      if (e.code == "F12") {
        e.cancelBubble = true;
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
    this.loading = false;
  },
  computed: {
    mountTitle() {
      if (
        !this.evaluations ||
        !this.evaluations[this.setup_index] ||
        !this.evaluations[this.setup_index].questions ||
        !this.evaluations[this.setup_index].questions[this.question_index]
      ) {
        return "";
      }

      const currentQuestion =
        this.evaluations[this.setup_index].questions[this.question_index];

      if (currentQuestion.details && currentQuestion.details.trim() !== "") {
        return `${currentQuestion.title}<p class='f14'>${currentQuestion.details}</p>`;
      }

      return currentQuestion.title || "";
    },
  },
  methods: {
    nextQuestion(answer) {
      if (this.validateAnswer(answer)) {
        this.loading = true;
        this.answer = "";
        this.stopTimer();
        this.startTimer();
        if (
          this.question_index !==
          this.evaluations[this.setup_index].questions.length - 1
        ) {
          this.evaluation_answer = {
            question_id:
              this.evaluations[this.setup_index].questions[
                this.question_index + 1
              ].id,
          };
        } else {
          this.evaluation_answer = {
            question_id:
              this.evaluations[this.setup_index].questions[this.question_index]
                .id,
          };
        }
        axios
          .post("/candidates/answers", { answers: this.evaluation_answer })
          .then((response) => {
            if (response.data.answer !== null) {
              if (
                this.question_index !==
                this.evaluations[this.setup_index].questions.length - 1
              ) {
                this.question_index = this.question_index + 1;
                return this.nextQuestion("skip_validation");
              } else {
                return this.nextEvaluation();
              }
            }
            if (
              this.question_index !==
              this.evaluations[this.setup_index].questions.length - 1
            ) {
              this.question_index = this.question_index + 1;
              this.loading = false;
            } else {
              this.nextEvaluation();
            }
          });
      }
    },
    validateAnswer(answer) {
      if (answer && answer !== "") {
        return true;
      }
      this.$toast.error("Responda a questão para continuar");
      return false;
    },
    nextEvaluation() {
      if (this.general_timer_interval) {
        clearInterval(this.general_timer_interval);
      }
      if (this.countdown) {
        clearInterval(this.countdown);
      }

      if (this.setup_index === this.evaluations.length - 1) {
        eventBus.$emit("finalScreen", { status: true });
        return;
      }

      this.has_timer = false;
      this.is_timer_counting = false;
      this.timer_minute = 0;
      this.timer_second = 0;
      localStorage.removeItem("timer_minute");
      localStorage.removeItem("timer_second");

      this.setup_index = this.setup_index + 1;
      this.question_index = 0;

      if (this.evaluations[this.setup_index].questions[this.question_index]) {
        this.evaluation_answer = {
          question_id:
            this.evaluations[this.setup_index].questions[this.question_index]
              .id,
        };
      }
      this.loading = false;
      this.showEvaluationStart(true);
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.currentTime += 1;
      }, 1000);
    },
    stopTimer() {
      window.clearInterval(this.timer);
      this.currentTime = 0;
    },
    showEvaluationStart(status) {
      if (!status && !this.is_timer_counting) {
        this.is_timer_counting = true;
        axios.put("/candidates", {
          candidates: {
            view_evaluation: this.candidate.view_evaluation + 1,
          },
        });
        if (
          this.has_timer &&
          !this.evaluations[this.setup_index].evaluation.time_per_question
        ) {
          this.general_timer_interval = setInterval(() => {
            if (
              localStorage.getItem("timer_second") &&
              localStorage.getItem("timer_second") == "end"
            ) {
              return;
            }
            if (
              this.timer_minute <= 0 &&
              this.timer_second <= 1 &&
              !this.evaluations[this.setup_index].evaluation.time_per_question
            ) {
              axios
                .put("/candidates", {
                  candidates: {
                    view_evaluation: 3,
                  },
                })
                .then(() => {});
              eventBus.$emit("finalScreen", { status: true });
              return;
            }

            this.timer_second = this.timer_second - 1;
            if (this.timer_second < 0) {
              this.timer_minute = this.timer_minute - 1;
              this.timer_second = 59;
            }
            localStorage.setItem("timer_second", this.timer_second);
            localStorage.setItem("timer_minute", this.timer_minute);
          }, 1000);
        }
      }

      this.saveCheckBoxesAgreed();

      this.show_evaluation_start = status;
    },
    startQuestionsTimer() {
      this.questionTime();
    },
    saveCheckBoxesAgreed() {
      const payload = {
        checkboxes: {
          agreed: [
            {
              evaluation_id: this.evaluations[this.setup_index].evaluation.id,
              texts: this.selectedCheckboxes,
            },
          ],
        },
      };

      axios.post(
        `/candidates/apply/${
          this.evaluations[this.setup_index].evaluation.id
        }/checkboxes_agreed`,
        payload
      );

      this.selectedCheckboxes = [];
    },
    questionTime() {
      if (!this.evaluations[this.setup_index].evaluation.time_per_question)
        return;

      const question =
        this.evaluations[this.setup_index].questions[this.question_index];

      if (question.time_to_respond <= 0) question.time_to_respond = 300;

      this.question_minutes = Math.floor(question.time_to_respond / 60);
      this.question_seconds = question.time_to_respond % 60;

      localStorage.setItem("question_minutes", this.question_minutes);
      localStorage.setItem("question_seconds", this.question_seconds);

      if (this.timer_second < 0) {
        this.timer_minute = this.timer_minute - 1;
        this.timer_second = 59;
      }
      localStorage.setItem("timer_second", this.timer_second);
      localStorage.setItem("timer_minute", this.timer_minute);
    },
    startCountdown() {
      const evaluation = this.evaluations[this.setup_index].evaluation;

      if (evaluation.time_per_question) {
        this.has_timer = true;
        return this.startQuestionsTimer();
      }

      const total_time = evaluation.time_total_to_response;

      if (typeof total_time === "number" && total_time > 0) {
        this.timer_minute = total_time;
        this.timer_second = 0;
        this.has_timer = true;
        return;
      }

      this.has_timer = false;
      this.timer_minute = 0;
      this.timer_second = 0;
      localStorage.removeItem("timer_minute");
      localStorage.removeItem("timer_second");
    },
    countFocusPage() {
      window.addEventListener("blur", () => {
        if (this.is_timer_counting == true) {
          axios
            .post("/candidates/apply/add_count_blur_view", {
              question_id: this.evaluation_answer.question_id,
            })
            .then(() => {});
        }
      });
    },
    truncate(title) {
      return title.length > 50
        ? title.slice(0, 50).trim().concat("...")
        : title;
    },
  },
  watch: {
    question_index() {
      if (this.evaluations[this.setup_index].evaluation.time_per_question) {
        this.questionTime();
      }
    },
    show_evaluation_start() {
      if (!this.show_evaluation_start) {
        axios
          .post("/candidates/answers", { answers: this.evaluation_answer })
          .then((response) => {
            if (response.data.answer !== null) {
              this.nextQuestion("skip_validation");
            } else {
              this.loading = false;
            }
          });
      }
    },
  },
};
</script>

<style></style>
